<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "AbrechnungNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id="11"></NewArticle>
</template>

<style scoped>

</style>
